const initRaffleEvent = {
  raffleEvents: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
};

export const raffleEventReducer = (state = initRaffleEvent, action: any) => {
  if (action.type === "SET_RAFFLE_EVENT") {
    return {
      ...state,
      raffleEvents: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_EVENT_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_RAFFLE_EVENT_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_RAFFLE_EVENT") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  return state;
};
